/**
 * The initial values for the redux state.
 */
export default {
  timestamp: 0,
  documents: [],
  fetchIsLoading: false,
  sorts: {
    doc_date: 'ascend'
  },
  filters: {},
  pageSize: '20',
  currentPage: 1,
  lastPage: 10,
  total: 0,
  selectedDocuments: [],
  workspaceIsVisible: false,
  printIsLoading: false,

  expandedRows: []
};
